<template lang="html">
  <div id="home-page">

    <section class="banner-section">
      <div class="container med-container">
        <div class="row">
          <div class="col-lg-6 col-content">
            <h2 class="mb-3 title">Revoluciona tu experiencia musical</h2>

            <h5 class="p-lg">TIPSONG conecta artistas con sus fans a través de una plataforma innovadora para eventos musicales.</h5>

            <p class="mt-3 mt-sm-4 ">
              <a class="btn btn-s1 btn-lg bg-1 mr-sm-3 mb-2 mb-sm-0" v-scroll-to="'#e-f'">Registrarse como Artista</a>
              <a class="btn btn-s1 btn-lg outline-1" v-scroll-to="'#e-c'">Conoce más</a>
            </p>
          </div>

          <div class="col-lg-6 col-xl-5 offset-xl-1 col-networks">
            <!-- <div class="box-network">
              <div class="flex-center-xy icon">
                <i class="fas fa-music"></i>
              </div>

              <h5>Próximamente en App Store y Google Play</h5>
            </div> -->

            <div class="box-video">
              <img class="img-fake" src="public/images/shared/empty.png">

              <video autoplay muted loop>
                <source src="public/videos/video.mp4" type="video/mp4">
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="benefits-section" id="e-c">
      <div class="container med-container">
        <div class="row">
          <div class="col-12 col-title">
            <h2 class="title-s1">Una plataforma completa para la música</h2>
          </div>

          <div class="col-md-6 col-info">
            <div class="box">
              <div class="b-icon">
                <div class="mb-4 circle">
                  <i class="fa-light fa-calendar"></i>
                </div>
              </div>

              <h5 class="mb-2">Consulta de Fechas</h5>
              <p>
                Los fans pueden consultar fácilmente las próximas fechas de conciertos y eventos de sus artistas favoritos.
              </p>
            </div>
          </div>

          <div class="col-md-6 col-info">
            <div class="box">
              <div class="b-icon">
                <div class="mb-4 circle">
                  <i class="fa-light fa-bags-shopping"></i>
                </div>
              </div>

              <h5 class="mb-2">Compra de Boletos y Merch</h5>
              <p>
                Adquiere boletos para eventos y merchandise oficial directamente desde la aplicación.
              </p>
            </div>
          </div>

          <div class="col-md-6 col-info">
            <div class="box">
              <div class="b-icon">
                <div class="mb-4 circle">
                  <i class="fa-light fa-chart-waterfall"></i>
                </div>
              </div>

              <h5 class="mb-2">Estadísticas para Artistas</h5>
              <p>
                Los artistas obtienen datos valiosos sobre la aceptación de su propuesta musical y el comportamiento de sus fans.
              </p>
            </div>
          </div>

          <div class="col-md-6 col-info">
            <div class="box">
              <div class="b-icon">
                <div class="mb-4 circle">
                  <i class="fa-light fa-user-group"></i>
                </div>
              </div>

              <h5 class="mb-2">Interacción Directa</h5>
              <p>
                Mejora la comunicación entre artistas y fans con herramientas de interacción directa.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="features-section"  id="e-b">
      <div class="container med-container">
        <div class="row">
          <div class="col-lg-6 col-info">
            <h3 class="mb-2 mb-lg-4 title-s1">Para los Fans</h3>

            <ul>
              <li>
                <p>Acceso a fechas de conciertos y eventos en un solo lugar</p>
              </li>
              <li>
                <p>Compra segura de boletos sin comisiones excesivas</p>
              </li>
              <li>
                <p>Merchandise oficial y exclusivo de tus artistas favoritos</p>
              </li>
              <li>
                <p>Notificaciones personalizadas sobre nuevos eventos</p>
              </li>
            </ul>
          </div>

          <div class="col-lg-6 col-info">
            <h3 class="mb-2 mb-lg-4 title-s1">Para los Artistas</h3>

            <ul>
              <li>
                <p>Estadísticas detalladas sobre la aceptación de tu música</p>
              </li>
              <li>
                <p>Gestión centralizada de eventos y ventas de merchandise</p>
              </li>
              <li>
                <p>Comunicación directa con tus fans más leales</p>
              </li>
              <li>
                <p>Afiliación gratuita con todas las funcionalidades</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="form-section-component" id="e-f">
      <b-form @submit="onSubmit">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-8 col-form">
              <h2 class="mb-2 text-center title-s1">Únete a TIPSONG</h2>

              <p class="text-center txt-c-3">Regístrate gratis como artista y comienza a revolucionar tu conexión con los fans</p>

              <div class="box-white">
                <div class="row">
                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Nombre del Artista/Banda*">
                      <b-form-input
                        v-model="form.name"
                        type="text"
                        placeholder="Nombre artístico"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Correo electrónico*">
                      <b-form-input
                        v-model="form.email"
                        type="email"
                        placeholder="tu@email.com"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Teléfono*">
                      <b-form-input
                        v-model="form.phone"
                        type="text"
                        minlength="10"
                        maxlength="10"
                        placeholder="12 3456 7890"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-6 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Género musical">
                      <b-form-select v-model="form.genreId">
                        <b-form-select-option :value="null">Seleccione un género</b-form-select-option>
                        <b-form-select-option :value="g.id" v-for="(g, gInx) in genres" :key="'gInx-'+gInx">{{ g.name }}</b-form-select-option>
                      </b-form-select>
                    </b-form-group>
                  </div>

                  <div class="col-lg-12 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Descripción">
                      <b-form-textarea
                        v-model="form.description"
                        placeholder="Cuéntanos sobre tu proyecto musical..."
                        rows="5"
                        max-rows="5"
                      ></b-form-textarea>
                    </b-form-group>
                  </div>

                  <div class="col-lg-12 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Logo de la banda">
                      <b-form-file v-model="form.image" plain></b-form-file>
                    </b-form-group>
                  </div>

                  <div class="col-lg-12 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Enlace de Spotify">
                      <b-form-input
                        v-model="form.spotify_url"
                        type="text"
                        placeholder="https:open.spotify.com/artist/..."
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-12 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Enlace de Facebook">
                      <b-form-input
                        v-model="form.facebook_url"
                        type="text"
                        placeholder="https://www.facebook.com/..."
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-12 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Enlace de Instagram">
                      <b-form-input
                        v-model="form.instagram_url"
                        type="text"
                        placeholder="https://www.instagram.com/..."
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-12 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Enlace de Youtube">
                      <b-form-input
                        v-model="form.youtube_url"
                        type="text"
                        placeholder="https://www.youtube.com/channel/..."
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-12 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Enlace de Tiktok">
                      <b-form-input
                        v-model="form.tiktok_url"
                        type="text"
                        placeholder="https://www.tiktok.com/..."
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-12 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Enlace de X (Twitter)">
                      <b-form-input
                        v-model="form.x_url"
                        type="text"
                        placeholder="https://www.x.com/..."
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-12 col-input">
                    <p class="mb-4">
                      <b-form-checkbox class="custom-checkbox-1"
                        v-model="form.checkbox"
                        required
                        name="checkbox-1"
                        :value="true"
                        :unchecked-value="false">
                        Acepto los <router-link target="_blank" to="/terminos-y-condiciones">Términos y condiciones</router-link> y el <router-link target="_blank" to="/aviso-de-privacidad">Aviso de privacidad</router-link> de TIPSONG
                      </b-form-checkbox>
                    </p>

                    <b-button type="submit" class="btn-s1 bg-1 w-100">Registrarse como Artista</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      genres: [],

      form: {
        image: null,
        genreId: null,
      },

      formErrors: [],
    }
  },

  methods: {
    getGenres: function(){
      axios.get(tools.url('/genres')).then(
        ({data}) =>{
          this.genres = data;
        });
    },

    onSubmit(event) {
      event.preventDefault();

      const formData = new FormData();

      Object.entries(this.form).forEach(([key, value]) => {
        if (value instanceof File) {
          // Para campos tipo archivo (como el b-form-file)
          formData.append(key, value);
        } else if (Array.isArray(value)) {
          // Si hay arrays (como v-select múltiple), agregarlos como múltiples campos
          value.forEach((val, index) => {
            formData.append(`${key}[${index}]`, val);
          });
        } else if (value !== null && value !== undefined) {
          // Para campos normales
          formData.append(key, value);
        }
      });

      axios.post(tools.url("/register"),formData).then((response)=>{
        if(response.data.status == 402) {
          this.formErrors.push(response.data.msg);
          alert('El correo que colocó ya esta siendo utilzado');
        }
        else {
          this.$router.push({ path: "/gracias" });
        }
      }).catch((error)=>{
        alert(error);
      });
    },
  },

  mounted() {
    this.getGenres();
  }
}
</script>
